export default "__VITE_ASSET__7VTkld_7__"